import { getMappedEnv } from '@atlassian/atlassian-studio-env-utils';

const PROD_BASE_URL = 'https://studio.atlassian.com';
const STAGING_BASE_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const DEV_BASE_URL = 'http://localhost:9000';

export const getStudioBaseUrl = (): string => {
	const env = getMappedEnv();
	switch (env) {
		case 'production':
			return PROD_BASE_URL;
		case 'staging':
			return STAGING_BASE_URL;
		case 'local':
			return DEV_BASE_URL;
		default:
			return DEV_BASE_URL;
	}
};
